export function getLoggedUser() {
  let userInfo = localStorage.getItem("mzad_user_info");
  userInfo = JSON.parse(userInfo);
  return userInfo;
}

export function getCurrentLocale() {
  return localStorage.getItem("I18N_LANGUAGE");
}
